import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import {findNestedValue} from 'ag-common/tools/objects'
import actions from 'redux-auto'

function InnerQuestionSetMenuItem({canEdit, text, finishedAnswersCount, questionsTotal}) {
  return (
    <span className="menu__item__text">
      {text}
      {canEdit && <span className="menu__item__questions">{`${finishedAnswersCount}/${questionsTotal}`}</span>}
    </span>
  )
}

InnerQuestionSetMenuItem.propTypes = {
  canEdit: PropTypes.any,
  finishedAnswersCount: PropTypes.any,
  questionsTotal: PropTypes.any,
  text: PropTypes.any,
}

function QuestionSetMenuItem({text, url, active, chapterStatus, questionsTotal, finishedAnswersCount, permissions}) {
  const canEdit = permissions.ausbildungsplan.edit
  const className = getModifierForChapter(active, chapterStatus)

  return (
    <Link to={url} className={`${className}`} onClick={() => actions.mobileMenu.closeMenu()}>
      <InnerQuestionSetMenuItem
        canEdit={canEdit}
        text={text}
        finishedAnswersCount={finishedAnswersCount}
        questionsTotal={questionsTotal}
      />
    </Link>
  )
}

function getModifierForChapter(active, chapterStatus) {
  let className = active ? 'menu__link menu__link__questionset active' : 'menu__link menu__link__questionset'
  className += ` menu__link--${chapterStatus}`
  return className
}

const mapStateToProps = (state, props) => {
  const chapterAnswers = state.ausbildungsplan.answers ? state.ausbildungsplan.answers[props.chapterId] : undefined

  return {
    chapterStatus: findNestedValue(state, [
      'ausbildungsplan',
      'chapterStatuses',
      props.userId,
      props.chapterId,
      'status',
    ]),
    finishedAnswersCount: chapterAnswers ? chapterAnswers.finishedAnswersCount : 0,
    permissions: state.authentication.permissions,
  }
}

QuestionSetMenuItem.propTypes = {
  text: PropTypes.string.isRequired,
  active: PropTypes.bool,
  questionsTotal: PropTypes.number,
  chapterStatus: PropTypes.string,
  finishedAnswersCount: PropTypes.number,
  url: PropTypes.string,
  permissions: PropTypes.object,
}

export default connect(mapStateToProps)(QuestionSetMenuItem)
